import { render, staticRenderFns } from "./LifemapSelectPane.vue?vue&type=template&id=22ebf80f&"
import script from "./LifemapSelectPane.vue?vue&type=script&lang=js&"
export * from "./LifemapSelectPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports